import { CultureInfo } from '../culture-info.model';
import { CultureInfoRu } from './ru';

/**
 * @ignore
 */
export const CultureInfoRuKG: CultureInfo = {
  name: 'ru-KG',
  displayName: 'русский (Киргизия)',
  iso3LanguageCode: 'rus',
  iso2LanguageCode: 'ru',
  ietfLanguageTag: 'ru-KG',
  parent: CultureInfoRu
};
